import { useEffect, useState } from 'react'
import { Divider, Select } from 'antd'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import { setFieldData } from '../CreateMacroDataProvider/actions'
import { getMemberKey, getNodeLabel } from 'Services/WeaverUtils'
import { Macro } from 'Model'
import { graph } from 'Model/constants'
import FormLikeField from './FormLikeField'


CreateFormConfig = ({ fieldKey }) ->

  [{ fieldData }, dispatch] = useCreateMacroData()
  [search, setSearch] = useState(undefined)

  [classNameOptions, setClassNameOptions] = useState([])
  [className, setClassName] = useState(undefined)

  [createFormOptions, setCreateFormOptions] = useState([])
  [createForm, setCreateForm] = useState(undefined)

  useEffect( ->
    ( ->
      macros = await Macro.list()
      setCreateFormOptions(
        macros.map((macro) ->
          { value: macro.id(), label: getNodeLabel(macro) }
        )
      )
      types = await new Weaver.Query()
        .hasRelationIn(getMemberKey())
        .notInGraph(graph)
        .find()
      setClassNameOptions(
        types.map((type) ->
          { value: type.id(), label: getNodeLabel(type) }
        )
      )
    )()
    undefined
  , [])

  setConfig = (key) -> (value) ->
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, 'config', key], value)
      )
    )

  <>
    <Divider />
    <FormLikeField label="Class name for created node">
      <Select
        onSearch={(val) -> setSearch(val) if val isnt ''}
        showSearch
        options={_.uniqBy(classNameOptions.concat([{ value: search, label: search }]), 'value')}
        style={{ width: '100%' }}
        value={fieldData[fieldKey]?.config?.className && [fieldData[fieldKey]?.config?.className]}
        onChange={setConfig('className')}
      />
    </FormLikeField>

    <FormLikeField label="Create form to use">
      <Select
        style={{ width: '100%' }}
        options={createFormOptions}
        disabled={createFormOptions.length is 0}
        value={fieldData[fieldKey]?.config?.createForm && [fieldData[fieldKey]?.config?.createForm]}
        onChange={setConfig('createForm')}
      />
    </FormLikeField>
    <Divider />
  </>

export default CreateFormConfig